import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  DvChipLegacyComponent,
  DvDynamicFormModule,
  DvNavTabsModule,
} from '@devinco/ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { NgxEchartsModule } from 'ngx-echarts';
import { StatisticsMenuComponent } from './components/statistics-menu/statistics-menu.component';
import { EmissionComponent } from './components/statistics-tabs/emission/emission.component';
import { HeatmapComponent } from './components/statistics-tabs/heatmap/heatmap.component';
import { MileageComponent } from './components/statistics-tabs/mileage/mileage.component';
import { ScoreComponent } from './components/statistics-tabs/score/score.component';
import { StatisticsTabsComponent } from './components/statistics-tabs/statistics-tabs.component';
import { TriggersComponent } from './components/statistics-tabs/triggers/triggers.component';
import { TripsComponent } from './components/statistics-tabs/trips/trips.component';
import { StatisticsTotalComponent } from './components/statistics-total/statistics-total.component';
import { StatisticsPageComponent } from './statistics-page.component';
import { PipesModule } from '@shared/pipes/pipes.module';
import { DvButtonComponent } from '@devinco/ui/dds';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { PinnedGroupsAreaComponent } from './components/statistics-menu/pinned-groups-area/pinned-groups-area.component';

export const StatisticsRouteName = {
  Main: 'statistics',
  Score: 'score',
  Triggers: 'triggers',
  Emission: 'emission',
  Mileage: 'mileage',
  Trips: 'trips',
  HeatMap: 'heatmap',
};
const routes: Routes = [
  {
    path: '',
    component: StatisticsPageComponent,
    children: [
      { path: '', redirectTo: StatisticsRouteName.Score, pathMatch: 'full' },
      {
        path: StatisticsRouteName.Score,
        component: ScoreComponent,
      },
      { path: StatisticsRouteName.Triggers, component: TriggersComponent },
      { path: StatisticsRouteName.Emission, component: EmissionComponent },
      { path: StatisticsRouteName.Mileage, component: MileageComponent },
      { path: StatisticsRouteName.Trips, component: TripsComponent },
      { path: StatisticsRouteName.HeatMap, component: HeatmapComponent },
    ],
  },
];

@NgModule({
  declarations: [
    StatisticsPageComponent,
    ScoreComponent,
    TriggersComponent,
    EmissionComponent,
    MileageComponent,
    TripsComponent,
    HeatmapComponent,
    StatisticsMenuComponent,
    StatisticsTotalComponent,
  ],
  imports: [
    StatisticsTabsComponent,
    ChipComponent,
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    DvChipLegacyComponent,
    DvButtonComponent,
    DvNavTabsModule,
    PipesModule,
    DvDynamicFormModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    PinnedGroupsAreaComponent,
  ],
})
export class StatisticsModule {}
